module.exports = __webpack_public_path__ + "06_face.03323d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/06_face.png
// module id = y5LT
// module chunks = 0